import {
  Button,
  Card,
  Checkbox,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import clsx from "clsx";
import React, { cloneElement, Component } from "react";
import { Translation } from "react-i18next";
import { FaTimes,FaCalendarAlt } from "react-icons/fa";
import {
  ColumnTypes,
  filterOperators,
  FilterOperatorTypes,
  filterOperatorsWithoutNew,
  filterOperatorsWithDateTime
} from "./table-view/TableTypes";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker
} from "@material-ui/pickers";
import { Autocomplete } from "@material-ui/lab";
import { getUserNameWithDetails } from 'util/CommonFunc';
import { DateRangePicker } from 'react-date-range';
import moment from "moment";
import DateRangeSelect from "_module/component/date-range-select/dateRangeSelect";
import { columnFieldConfig } from "modules/column-config/ColumnConfig";

const defaultFilter = (column) => {
  return {
    operator:
      filterOperators.filter((v) => v.input.includes(column.type))[0]
        ?.operator || FilterOperatorTypes.contains,
    value: [],
  };
};

class TableColFilter extends Component {
  constructor(props) {
    super();
    const {
      column,
      includeNewFilter,
      includeNewFiltersWithDateTime,
      data: {
        query: { filters },
      },
    } = props;
    this.state = {
      anchorEl: null,
      filter:
        filters.find((v) => v.field === column.field) || defaultFilter(column),
      userFilterText: "",
      BetweenDateValue:"",
      isBetWeenDateValid:true,
      dateRangeSelectOpen:false,
      dateRanges: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      }
    };
    this.operators = (includeNewFiltersWithDateTime ? filterOperatorsWithDateTime : includeNewFilter? filterOperators : filterOperatorsWithoutNew).filter((v) =>
      v.input.includes(column.type)
    );
  }

  operators;

  onKeyDown = (e) => {
    const {
      search,
      data: { query },
    } = this.props;
    if (e.key === "Enter") {
      search({ ...query, page: 0 });
    }
  };

  componentDidUpdate(prevprops) {
    const {
      column,
      data: {
        query: { filters },
      },
    } = this.props;

    if (!this.compareFilters(prevprops?.data?.query?.filters, filters)) {
      this.setState({
        filter:
          filters.find((v) => v.field === column.field) ||
          defaultFilter(column),
      });
    }
  }

  compareFilters(x, y) {
    let objectsAreSame = true;
    for (let propertyName in x) {
      if (x[propertyName] !== y[propertyName]) {
        objectsAreSame = false;
        break;
      }
    }
    return objectsAreSame;
  }

  handleBetweenDateChange = (value, shouldSearch = false) =>{
    let bDates=[]; 
    this.state.isBetWeenDateValid  = true;   
    this.setState({BetweenDateValue:value})                      
    if(value.includes("-")){                  
      bDates = value.split('-').map(e=>{        
        if(moment(e, "DD-MM-YYYY").toISOString() != null && !e.includes("-")){
          return moment(e, "DD-MM-YYYY").toISOString(); 
        } 
        else{
          this.state.isBetWeenDateValid  = false;
        }                 
                    
      }).filter(e => e);

      if(bDates.length == 2 && this.state.isBetWeenDateValid){
        this.setFilter(bDates,shouldSearch);
      }      
  }
  else{
    this.state.isBetWeenDateValid  = false;
  }
}

  onIsEmptyClear = (column)=>{
    this.setState(
      { filter: defaultFilter(column) },
      () => {
        this.setFilter(this.state.filter.value, true);
        this.handleClose();
      }
    );
  }

  onOperatorChange = (operator) => {
    const {
      column,
    } = this.props;
    let prevFilter = this.state.filter.operator;
    this.setState(
      { filter: { ...this.state.filter, operator: operator } },
      () => {
        this.setFilter(this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty || this.state.filter.operator == FilterOperatorTypes.between || prevFilter == FilterOperatorTypes.between? [] : this.state.filter.value, this.state.filter.operator == FilterOperatorTypes.between? false : true);
        if(this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty || this.state.filter.operator == FilterOperatorTypes.between){
          if(column.type == ColumnTypes.date || column.type == ColumnTypes.datetime){
           this.setState({dateRanges:{startDate:new Date(), endDate:new Date(),  key: 'selection'}});
          }
        }
        this.handleClose();
      }
    );
  };

  setFilter = (v, shouldSearch = false) => {
    const {
      data: {
        query,
        query: { filters },
      },
      column,
      setQuery,
      search,
    } = this.props;
    this.setState({ filter: { ...this.state.filter, value: v } }, () => {
      let newfilters = [...filters];
      let index = filters.findIndex((f) => f.field === column.field);
      if (index > -1 && v.length) {
        newfilters[index].value = v;
        newfilters[index].operator = this.state.filter.operator;
      } else if (index > -1){
        if(this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty || this.state.filter.operator == FilterOperatorTypes.between){
          newfilters[index].value = v;
          newfilters[index].operator = this.state.filter.operator;
        }
        else{
          newfilters.splice(index, 1);
        }
        
      } 
      else if(index == -1 && (this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty || this.state.filter.operator == FilterOperatorTypes.between)){
        newfilters.push({ ...this.state.filter, field: column.field });
      }
      else if (v.length){
        if(column.isAdditional){
          newfilters.push({ ...this.state.filter, field: column.field, isAdditional: column.isAdditional}); 
        }
        else{
          newfilters.push({ ...this.state.filter, field: column.field}); 
        }
        // newfilters.push({ ...this.state.filter, field: column.field, isAdditional: column.isAdditional? column.isAdditional : false  });
      }
        

      let newQuery = { ...query, filters: newfilters, page: 0 };
      setQuery(newQuery, () => {
        if (shouldSearch) search(newQuery);
      });
    });
  };

  handleClick = (event) => this.setState({ anchorEl: event.currentTarget });
  handleClose = () => this.setState({ anchorEl: null });

  getFilterTitle(filterType) {
    switch (filterType) {
      case FilterOperatorTypes.contains:
        return "Contains";
      case FilterOperatorTypes.notEquals:
        return "Not Equals";
      case FilterOperatorTypes.equals:
        return "Equals";
      case FilterOperatorTypes.notContains:
        return "Not Contains";
      case FilterOperatorTypes.startsWith:
        return "Starts With";
      case FilterOperatorTypes.notStartsWith:
        return "Not Starts With";
      case FilterOperatorTypes.endsWith:
        return "Ends With";
      case FilterOperatorTypes.notEndsWith:
        return "Not Ends With";
      case FilterOperatorTypes.exactly:
        return "Exactly";
      case FilterOperatorTypes.notExactly:
        return "Not Exactly";
      case FilterOperatorTypes.greaterThan:
        return "Greater Than";
      case FilterOperatorTypes.lessThan:
        return "Less Than";
      case FilterOperatorTypes.greaterThanEqual:
        return "Greater Than or Equal";
      case FilterOperatorTypes.lessThanEqual:
        return "Less Than or Equal";
      case FilterOperatorTypes.range:
        return "Rang";
      case FilterOperatorTypes.conjAnd:
        return "And";
      case FilterOperatorTypes.conjOr:
        return "Or";
      case FilterOperatorTypes.between:
        return "Between";
      case FilterOperatorTypes.empty:
        return "Empty";
      case FilterOperatorTypes.notEmpty:
        return "Not Empty";
      case FilterOperatorTypes.dateTime:
        return "Date Time";
      default:
        return null;
    }
  }

  handleSelectDateRange=(ranges)=>{
    this.setState({dateRanges:{...ranges}},()=>{    
    });
  }

  addSelectedDateRange=()=>{
    const endDate = new Date(this.state.dateRanges.endDate);
    endDate.setDate(endDate.getDate()+1);
    this.setFilter([this.state.dateRanges.startDate,endDate],true);
  }

  handleRangeSelectClose = ()=>{
    this.setState({dateRangeSelectOpen:false})
  }

  getInputter = (isFilterActive,t) => {
    const { classes, column : baseColumn, row, allUsers } = this.props;

    const {isBetWeenDateValid, dateRanges ,dateRanges : {startDate,endDate}} = this.state;

    let column = baseColumn.extentedProps? columnFieldConfig(baseColumn,row) : baseColumn ;


    let ariaLabelText = this.getFilterTitle(this.state.filter.operator);
    const { filterProps } = column.cellProp
      ? column.cellProp(row, this.props)
      : {};
    const CustomAutoCompleteWrapper = function (props) {
      return <div {...props} className={classes.autocompleteWrapper} placement="bottom-start"></div>;
    };
    switch (column.type) {
      case ColumnTypes.users:
        if (allUsers?.length > 0) {
          return (
            <Autocomplete
              forcePopupIcon={false}
              disableClearable
              limitTags={1}
              filterSelectedOptions
              sx={{ width: 300 }}
              id="filter-users"
              aria-label = {"Users"}
              options={allUsers}
              getOptionLabel={(item) => getUserNameWithDetails(item)}
              onChange={(event, users) => {
                 this.setFilter(
                  [users.externalRefId]
                 );
              }}
              onClose={() => {
                setTimeout(() => {
                  const {
                    data: { query },
                    search,
                  } = this.props;
                  search({ ...query, page: 0 });
                }, 300);
              }}
              value={
                allUsers && allUsers.length && this.state.filter.value?.length > 0
                  ? allUsers.find((d) =>
                      this.state.filter.value.find((s) => d.externalRefId == s)
                    )
                  : null
              }
              renderInput={(params) => (
                <TextField
                  className={classes.userClBlocks}                               
                  variant="outlined"
                  // label="Users"
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    'aria-label':"Users"
                  }}
                />
              )}
              PaperComponent={CustomAutoCompleteWrapper}
            />
          );
        } else {
          return <div className={clsx(
            classes.tableFilterSelect,
            isFilterActive ? classes.tableTextAvailable : ""
          )}>...</div>;
        }

      case ColumnTypes.options:
        return (
          <Select
            aria-label={
              filterProps &&
              filterProps.ariaLable &&
              !this.state.filter.value[0]
                ? filterProps.ariaLable
                : this.state.filter.value[0] || ariaLabelText
            }
            multiple
            variant="outlined"
            value={this.state.filter.value || []}
            inputProps={{
              id: `${(typeof column.label === 'string'?  column.label.replace(" ", "") : column.field) + "_" + ariaLabelText}`,
              "aria-labelledby": `${
                (typeof column.label === 'string'?  column.label.replace(" ", "") : column.field) + "_" + ariaLabelText
              }`,
              "aria-label": `${
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }`,
            }}
            onChange={(event) => {
              this.setFilter(event.target.value);
            }}
            onClose={() => {
              const {
                data: { query },
                search,
              } = this.props;
              search({ ...query, page: 0 });
            }}
            className={clsx(
              classes.tableFilterSelect,
              isFilterActive ? classes.tableTextAvailable : "",
              this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty? classes.emptyFilterIcon : ""
            )}
            title={
              this.state.filter.value
                .map(
                  (x) =>
                    column.filterOptions?.filter(
                      (option) => option.id === x
                    )?.[0]?.label
                )
                .filter(function( element ) {
                  return element !== undefined;
                })
                .join(", ") || ""
            }
            renderValue={(selected) =>
              selected
                .map(
                  (x) =>
                    column.filterOptions?.filter(
                      (option) => option.id === x
                    )?.[0]?.label
                )
                .filter(function( element ) {
                  return element !== undefined;
                })
                .join(", ")
            }

            MenuProps={{ variant: "menu" }}
          >
            {column.filterOptions?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {
                  <Checkbox
                    checked={this.state.filter.value.includes(option.id)}
                    inputProps={{
                      "aria-label": `${ariaLabelText}`,
                    }}
                  />
                }
                {option.label}
              </MenuItem>
            ))}
          </Select>
        );

      case ColumnTypes.number:
        return (
          <div className={classes.dateTimeFilter}
          >
          <>
           {this.state.filter.operator == FilterOperatorTypes.between ? (
             <>
              <TextField
                  aria-label={
                    filterProps &&
                    filterProps.ariaLable &&
                    !this.state.filter.value[0]
                      ? filterProps.ariaLable
                      : this.state.filter.value[0] || ariaLabelText
                  }
                  min="0"
                  value={this.state.filter.value[0] || "0"}
                  onChange={(event) => {
                    if(event.currentTarget.value){
                      this.setFilter(
                        event.currentTarget.value ? [event.currentTarget.value, this.state.filter.value[1] || "0"] : []
                      );
                    }
                    
                  }}
                  type="number"
                  onKeyDown={this.onKeyDown}
                  className={clsx(classes.tableFilterInput, classes.leftBorder, classes.root, "removePadding")}
                  InputLabelProps={{
                    classes: {
                      root: classes.tableInputLabel,
                      focused: classes.tableInputFocused,
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.tableInputOutlinedInput,
                      focused: classes.tableInputFocused,
                      notchedOutline: classes.tableNotchedOutline,
                    },
                  }}
                  inputProps={{
                    "aria-label": `${
                      filterProps &&
                      filterProps.ariaLable &&
                      !this.state.filter.value[0]
                        ? filterProps.ariaLable
                        : this.state.filter.value[0] || ariaLabelText
                    }`,
                    min: 0,
                  }}
                  variant="outlined"
                />
              <TextField
                aria-label={
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[1]
                    ? filterProps.ariaLable
                    : this.state.filter.value[1] || ariaLabelText
                }
                min="0"
                value={this.state.filter.value[1] || "0"}
                onChange={(event) => {
                  if(event.currentTarget.value){
                    this.setFilter(
                      event.currentTarget.value ? [this.state.filter.value[0] || "0", event.currentTarget.value] : []
                    );
                  }
                  
                }}
                type="number"
                onKeyDown={this.onKeyDown}
                className={clsx(classes.tableFilterInput,classes.FilterDate, "removePadding", classes.root, (!this.state.filter.value[1] && !this.state.filter.value[0]) ?"betweenFilterZero" : "")}
                InputLabelProps={{
                  classes: {
                    root: classes.tableInputLabel,
                    focused: classes.tableInputFocused,
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.tableInputOutlinedInput,
                    focused: classes.tableInputFocused,
                    notchedOutline: classes.tableNotchedOutline,
                  },
                }}
                inputProps={{
                  "aria-label": `${
                    filterProps &&
                    filterProps.ariaLable &&
                    !this.state.filter.value[0]
                      ? filterProps.ariaLable
                      : this.state.filter.value[0] || ariaLabelText
                  }`,
                  min: 0,
                }}
                variant="outlined"
              />
             </>
           ) : (
              <TextField
              aria-label={
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }
              placeholder={this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty?  t(`filterOperatotors.${this.state.filter.operator}`) : ""}
              min="0"
              disabled={this.state.filter.operator== FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty? true :  null}
              value={this.state.filter.value[0] || ""}
              onChange={(event) => {
                this.setFilter(
                  event.currentTarget.value ? [event.currentTarget.value] : []
                );
              }}
              type="number"
              onKeyDown={this.onKeyDown}
              className={clsx(classes.tableFilterInput,classes.root)}
              InputLabelProps={{
                classes: {
                  root: classes.tableInputLabel,
                  focused: classes.tableInputFocused,
                },
              }}
              InputProps={{
                classes: {
                  root: classes.tableInputOutlinedInput,
                  focused: classes.tableInputFocused,
                  notchedOutline: classes.tableNotchedOutline,
                },
              }}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                }`,
                min: 0,
              }}
              variant="outlined"
            />
           )}
          </>
          </div>
        );

      case ColumnTypes.boolean:
        return (          
          <Select
            aria-label={
              filterProps &&
              filterProps.ariaLable &&
              !this.state.filter.value[0]
                ? filterProps.ariaLable
                : this.state.filter.value[0] || ariaLabelText
            }
            multiple
            variant="outlined"
            value={this.state.filter.value || []}
            inputProps={{
              id: `${column.label.replace(" ", "") + "_" + ariaLabelText}`,
              "aria-labelledby": `${
                column.label.replace(" ", "") + "_" + ariaLabelText
              }`,
              "aria-label": `${
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }`,
            }}
            onChange={(event) => {
              this.setFilter(event.target.value);
              const {
                data: { query },
                search,
              } = this.props;
              search({ ...query, page: 0 });
            }}
            // onClose={() => {
            //   const {
            //     data: { query },
            //     search
            //   } = this.props;
            //   search({ ...query, page: 0 });
            // }}
            className={clsx(
              classes.tableFilterSelect,
              isFilterActive ? classes.tableTextAvailable : ""
            )}
            title={
              this.state.filter.value
                .map(
                  (x) =>
                    column.filterOptions?.filter(
                      (option) => option.id === x
                    )?.[0]?.label
                )
                .join(", ") || ""
            }
          >
            {column.filterOptions?.map((option) => {
              return (
                <MenuItem key={option.id} value={option.id}>
                  {option.label}
                </MenuItem>
              );
            })}
          </Select>
        );

      case ColumnTypes.date:
        return (
          <div className={classes.dateTimeFilter}
          >
          <>
          {this.state.filter.operator == FilterOperatorTypes.between ?
            <>    

             <div className={clsx(classes.tableFilterDateRange, "DateRangeButton")}>
             <DateRangeSelect
            rangeSelectOpen={this.state.dateRangeSelectOpen}
            rangeSelectClose={this.handleRangeSelectClose}
            rangeSelectBoxTitle={column.label}
            setDateRange={(range,reset=false)=>{
              this.handleSelectDateRange(range,reset);
              if(reset && this.state.filter.value[0]){
                this.setFilter([]);
              }
            }}
            rangeSelectConfirmedClick={()=>{
              this.addSelectedDateRange();
              this.handleRangeSelectClose();
            }}
            dateRange={dateRanges}
            classes={classes}
            variant="outlined"
            />
            <TextField  
              className={clsx("customColorforInput",classes.tableFilterInput,classes.tableFilterDate,this.state.filter.value[0] ? "searchHighlighter" : null)}
              // value={moment(startDate).format("DD/MM/YYYY")}
              value={`${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`}
              disabled={true}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                } Between`,
              }}
              />
              
              {/* <TextField  
              className={clsx("customColorforInput",classes.tableFilterInput,classes.tableFilterDate,this.state.filter.value[0] ? "searchHighlighter" : null)}
              value={moment(endDate).format("DD/MM/YYYY")}
              disabled={true}
              /> */}
            <Button
                // className={classes.tableFilterIcons}
                onClick={(e)=>{
                  this.setState({dateRangeSelectOpen:true})
                }}
              >
                {<FaCalendarAlt />}
              </Button>
             </div>         

              {/* <TextField
              placeholder={`dd/mm/yyyy-dd/mm/yyyy`} 
              id={`colfilter${column.field}_Between`}
              key={`colfilter${column.field}_Between`}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                }`,
              }}
              className={clsx(classes.tableFilterInput, classes.root, isBetWeenDateValid == false? "invalidFormate" : null)}
              value={this.state.BetweenDateValue}
              onChange={(event) => {
                this.setState({BetweenDateValue:event.target.value, isBetWeenDateValid:true})
                
              }}
              onBlur={(event)=>{
                if(event.currentTarget.value){
                  this.handleBetweenDateChange(
                    event.currentTarget.value ? event.currentTarget.value : []
                  );
                }
                
              }}
              // helperText={isBetWeenDateValid == false? "Invalid Format" : null}
              onKeyDown={(event)=>{
                if(this.state.BetweenDateValue && event.key === "Enter"){
                  this.handleBetweenDateChange(
                    this.state.BetweenDateValue ? this.state.BetweenDateValue : [], true
                  );
                }
                
              }}
              variant="outlined"
            >
               
               </TextField> */}

            </>
          :
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                aria-label={
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                }
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                className={clsx(
                  classes.tableFilterInput,
                  classes.tableFilterDate,
                  classes.FilterDate
                )}
                disabled={this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty? true : null}
                // value={this.state.filter.value[0] ? moment(this.state.filter.value[0], 'DD-MM-yyyy').toDate() : null}
                value={this.state.filter.value[0] || null}
                onChange={(event) => {
                  this.setFilter(
                    event ? [event] : [],
                    // event ? [moment(event).format('DD-MM-yyyy')] : [],
                    true
                  );
                }}
                onKeyDown={this.onKeyDown}
                autoOk
                inputProps={{
                  "aria-label": `${
                    filterProps &&
                    filterProps.ariaLable &&
                    !this.state.filter.value[0]
                      ? filterProps.ariaLable
                      : this.state.filter.value[0] || ariaLabelText
                  }`,
                }}
              />
            </MuiPickersUtilsProvider>
        }
          </>
          </div>
        );

      case ColumnTypes.datetime:
        return (
          <div className={classes.dateTimeFilter}
          >
          <>
          {this.state.filter.operator == FilterOperatorTypes.between ?
            <>
             <div className={clsx(classes.tableFilterDateRange, "DateRangeButton")}>
             <DateRangeSelect
            rangeSelectOpen={this.state.dateRangeSelectOpen}
            rangeSelectClose={this.handleRangeSelectClose}
            rangeSelectBoxTitle={column.label}
            setDateRange={(range,reset=false)=>{
              this.handleSelectDateRange(range,reset);
              if(reset && this.state.filter.value[0]){
                this.setFilter([]);
              }
            }}
            rangeSelectConfirmedClick={()=>{
              this.addSelectedDateRange();
              this.handleRangeSelectClose();
            }}
            dateRange={dateRanges}
            classes={classes}
            variant="outlined"
            />
            <TextField  
              className={clsx("customColorforInput",classes.tableFilterInput,classes.tableFilterDate,this.state.filter.value[0] ? "searchHighlighter" : null)}
              // value={moment(startDate).format("DD/MM/YYYY")}
              value={`${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                } Between`,
              }}
              disabled={true}
              />
              
              {/* <TextField  
              className={clsx("customColorforInput",classes.tableFilterInput,classes.tableFilterDate,this.state.filter.value[0] ? "searchHighlighter" : null)}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                } To`,
              }}
              value={moment(endDate).format("DD/MM/YYYY")}
              disabled={true}
              /> */}
            <Button
                // className={classes.tableFilterIcons}
                onClick={(e)=>{
                  this.setState({dateRangeSelectOpen:true})
                }}
              >
                {<FaCalendarAlt />}
              </Button>
             </div>
              
              {/* <TextField
              placeholder={`dd/mm/yyyy-dd/mm/yyyy`} 
              id={`colfilter${column.field}_Between`}
              key={`colfilter${column.field}_Between`}
              inputProps={{
                "aria-label": `${
                  filterProps &&
                  filterProps.ariaLable &&
                  !this.state.filter.value[0]
                    ? filterProps.ariaLable
                    : this.state.filter.value[0] || ariaLabelText
                }`,
              }}
              className={clsx(classes.tableFilterInput, classes.root, isBetWeenDateValid == false? "invalidFormate" : null)}
              value={this.state.BetweenDateValue}
              onChange={(event) => {
                this.setState({BetweenDateValue:event.target.value, isBetWeenDateValid:true})
                
              }}
              onBlur={(event)=>{
                if(event.currentTarget.value){
                  this.handleBetweenDateChange(
                    event.currentTarget.value ? event.currentTarget.value : []
                  );
                }
                
              }}
              // helperText={isBetWeenDateValid == false? "Invalid Format" : null}
              onKeyDown={(event)=>{
                if(this.state.BetweenDateValue && event.key === "Enter"){
                  this.handleBetweenDateChange(
                    this.state.BetweenDateValue ? this.state.BetweenDateValue : [],true
                  );
                }
                
              }}
              variant="outlined"
            >
               </TextField> */}
            </>
          :
          this.state.filter.operator == FilterOperatorTypes.dateTime ?(
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            aria-label={
              filterProps &&
              filterProps.ariaLable &&
              !this.state.filter.value[0]
                ? filterProps.ariaLable
                : this.state.filter.value[0] || ariaLabelText
            }
            variant="inline"
            format="dd/MM/yyyy hh:mm"
            margin="normal"
            className={clsx(
              classes.tableFilterInput,
              classes.tableFilterDate,
              classes.FilterDate
            )}
            // value={this.state.filter.value[0] ? moment(this.state.filter.value[0], 'DD-MM-yyyy').toDate() : null}
            value={this.state.filter.value[0] || null}
            onChange={(event) => {
              this.setFilter(
                event ? [event] : [],
                // event ? [moment(event).format('DD-MM-yyyy')] : [],
                true
              );
            }}
            onKeyDown={this.onKeyDown}
            autoOk
            inputProps={{
              "aria-label": `${
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }`,
            }}
          />
        </MuiPickersUtilsProvider>
          )
          :
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            aria-label={
              filterProps &&
              filterProps.ariaLable &&
              !this.state.filter.value[0]
                ? filterProps.ariaLable
                : this.state.filter.value[0] || ariaLabelText
            }
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            className={clsx(
              classes.tableFilterInput,
              classes.tableFilterDate,
              classes.FilterDate
            )}
            disabled={this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty? true : null}
            // value={this.state.filter.value[0] ? moment(this.state.filter.value[0], 'DD-MM-yyyy').toDate() : null}
            value={this.state.filter.value[0] || null}
            onChange={(event) => {
              this.setFilter(
                event ? [event] : [],
                // event ? [moment(event).format('DD-MM-yyyy')] : [],
                true
              );
            }}
            onKeyDown={this.onKeyDown}
            autoOk
            inputProps={{
              "aria-label": `${
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }`,
            }}
          />
        </MuiPickersUtilsProvider>
          }
           
          </>
          </div>
        );

      default:
        return (
          <TextField
            aria-label={
              filterProps &&
              filterProps.ariaLable &&
              !this.state.filter.value[0]
                ? filterProps.ariaLable
                : this.state.filter.value[0] || ariaLabelText
            }
            placeholder={this.state.filter.operator && (this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty)?  t(`filterOperatotors.${this.state.filter.operator}`) : ""}
            value={this.state.filter.value[0] || ""}
            disabled={this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty? true :  null}
            onChange={(event) => {
              this.setFilter(
                event.currentTarget.value ? [event.currentTarget.value] : []
              );
            }}
            onKeyDown={this.onKeyDown}
            className={clsx(classes.tableFilterInput, classes.root)}
            InputLabelProps={{
              classes: {
                root: classes.tableInputLabel,
                focused: classes.tableInputFocused,
              },
            }}
            inputProps={{
              "aria-label": `${
                filterProps &&
                filterProps.ariaLable &&
                !this.state.filter.value[0]
                  ? filterProps.ariaLable
                  : this.state.filter.value[0] || ariaLabelText
              }`,
            }}
            InputProps={{
              classes: {
                root: classes.tableInputOutlinedInput,
                focused: classes.tableInputFocused,
                notchedOutline: classes.tableNotchedOutline,
              },
            }}
            variant="outlined"
          />
        );
    }
  };

  render() {
    const { classes, column } = this.props;

    const filterActive = this.state.filter.value.length ? true : false;

    const {
      anchorEl,
      filter: { operator },
    } = this.state;
    const selectedOperator = this.operators.find(
      (v) => v.operator === operator
    );

    return (
      <Translation>
        {(t, { i18n }) => (
          <Card
            className={clsx(
              filterActive
                ? clsx(classes.tableActiveFilter, this.state.filter.operator == FilterOperatorTypes.between?"AdvactiveFilter":"")
                : classes.tableInactiveFilter,
              classes.tableColumnWrap, classes.tableUserDataWrap
            )}
          >
            <Button
              className={clsx(
                classes.tableFilterIcons,
                classes.tableFilterIcon
              )}
              aria-label={
                column && (column.label || column.name)
                  ? `${column.label || column.name} ${this.getFilterTitle(
                      operator
                    )}`
                  : this.getFilterTitle(operator)
              }
              onClick={this.handleClick}
              title={this.getFilterTitle(operator)}
            >
              {selectedOperator &&
                cloneElement(selectedOperator.icon, {
                  className: filterActive
                    ? classes.activeFilter
                    : classes.inactiveFilter,
                })}
              <span
                className={
                  selectedOperator && selectedOperator.isAnot
                    ? "notCondition"
                    : ""
                }
              ></span>
            </Button>
            <Menu
              keepMounted
              getContentAnchorEl={null}
              anchorOrigin={{
                horizontal: "left",
                vertical: "bottom",
              }}
              id="column-filter"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
              className={classes.tableFilterList}
            >
              {this.operators.map((op) => {
                return (
                  <MenuItem
                    key={op.operator}
                    disabled={operator === op.operator}
                    onClick={() => {
                      this.onOperatorChange(op.operator);
                    }}
                  >
                    {cloneElement(op.icon)}
                    <span className={op.isAnot ? "notCondition" : ""}></span>
                    {t(`filterOperatotors.${op.operator}`)}
                  </MenuItem>
                );
              })}
            </Menu>
            {/* <Tooltip title={ filter ? filterItemDiscription(filter, columns) : null}> */}
            {this.getInputter(filterActive,t)}
            {/* </Tooltip> */}
            {filterActive && (
              <Button
                className={classes.tableFilterClear}
                onClick={() =>{
                  if(this.state.filter.operator == FilterOperatorTypes.between && (column.type == ColumnTypes.date || column.type == ColumnTypes.datetime)){
                    this.setState({BetweenDateValue: "", isBetWeenDateValid:true,dateRanges:{startDate:new Date(), endDate:new Date(), key: 'selection'}},()=>{
                      // this.setFilter([], true)
                      this.onIsEmptyClear(column);
                    })
                  }
                  else{
                    this.setFilter([], true)
                  }
                }}
                aria-label="Clear filter"
              >
                {<FaTimes />}
              </Button>
            )}
            {!filterActive && (this.state.filter.operator == FilterOperatorTypes.empty || this.state.filter.operator == FilterOperatorTypes.notEmpty) &&  (
              <Button
                className={classes.tableFilterClear}
                onClick={() => this.onIsEmptyClear(column)}
                aria-label="Clear filter"
              >
                {<FaTimes />}
              </Button>
            )}
          </Card>
        )}
      </Translation>
    );
  }
}

export default TableColFilter;
